import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { useFormatPrice } from "@/lib/use-format-price";

// Renders a price (stored in RUB, shown in the buyer's chosen display currency)
// with the OSMIX bold-body type ramp. `size` picks the type scale so the same
// component reads right in a card, on a detail page, or in a cart line.
// `from` больше не показывается (A-09, Айталы 02.10.2026): каждая карточка —
// один вариант товара, и цена — ровно этого варианта, без «от». Проп оставлен,
// чтобы вызовы в экранах компилировались; зоны уберут его во втором заходе.
// Цена не переносится: formatPrice ставит неразрывные пробелы, а элемент —
// white-space: nowrap (data-slot="price", styles/globals.css). Если места мало,
// на новую строку уходит старая цена целиком (flex-wrap), а не «₽».
export function Price(t0) {
  const $ = _c(37);
  const {
    value,
    oldValue,
    size: t1,
    sale: t2,
    pill,
    minQty,
    className
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const sale = t2 === undefined ? false : t2;
  const {
    t
  } = useTranslation();
  const fmt = useFormatPrice();
  const type = size === "lg" ? "type-h2" : size === "sm" ? "type-body2-bold" : "type-body1-bold";
  const oldType = size === "lg" ? "type-body1" : "type-body2";
  const showOld = oldValue != null && oldValue > value;
  const tone = pill ?? (sale ? "tangelo" : undefined);
  const showBadge = showOld && tone != null;
  const t3 = size === "lg" ? "h-[17px] rounded-full px-[5px] text-[12px]" : "h-[13px] rounded-[6px] px-1 text-[10px]";
  const t4 = tone === "tangelo" ? "bg-osmix-tangelo" : "bg-osmix-text-1";
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = cn("flex items-center self-center whitespace-nowrap font-bold leading-none text-white", t3, t4);
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const badge = t5;
  let t6;
  if ($[3] !== oldValue || $[4] !== showOld || $[5] !== value) {
    t6 = showOld ? Math.round((1 - value / (oldValue as number)) * 100) : 0;
    $[3] = oldValue;
    $[4] = showOld;
    $[5] = value;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const percent = t6;
  const priceColor = tone === "tangelo" ? "text-osmix-tangelo" : tone === "dark" ? "text-osmix-text-1" : "text-osmix-text-2";
  let t7;
  if ($[7] !== className) {
    t7 = cn("inline-flex flex-wrap items-baseline gap-x-2", className);
    $[7] = className;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== priceColor || $[10] !== type) {
    t8 = cn(type, priceColor);
    $[9] = priceColor;
    $[10] = type;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== fmt || $[13] !== value) {
    t9 = fmt(value);
    $[12] = fmt;
    $[13] = value;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <span className={t8}>{t9}</span>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== fmt || $[19] !== oldType || $[20] !== oldValue || $[21] !== showOld) {
    t11 = showOld && <span className={cn(oldType, "text-osmix-icon line-through")}>{fmt(oldValue)}</span>;
    $[18] = fmt;
    $[19] = oldType;
    $[20] = oldValue;
    $[21] = showOld;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== badge || $[24] !== percent || $[25] !== showBadge) {
    t12 = showBadge && percent > 0 && <span className={badge}>-{percent}%</span>;
    $[23] = badge;
    $[24] = percent;
    $[25] = showBadge;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== badge || $[28] !== minQty || $[29] !== t) {
    t13 = minQty != null && minQty > 1 && <span className={badge} data-testid="min-order-badge">{t("product.minOrderBadge", {
        defaultValue: "\u043E\u0442 {{count}} \u0448\u0442.",
        count: minQty
      })}</span>;
    $[27] = badge;
    $[28] = minQty;
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t12 || $[34] !== t13 || $[35] !== t7) {
    t14 = <span data-slot="price" className={t7}>{t10}{t11}{t12}{t13}</span>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t7;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
}